import { autorun, computed, makeObservable } from "mobx";
import { type Department, type User } from "../../api";
import type { ServiceAuth } from "./service-auth";
import * as Sentry from "@sentry/browser";
import type { RepositoryUsers } from "../repositories/repository-users";
import type { RepositoryDepartments } from "../repositories/repository-departments";

// This service manages the currently logged in user.

export class ServiceOwnUser {
    constructor(
        private readonly serviceAuth: ServiceAuth,
        private readonly repositoryUsers: RepositoryUsers,
        private readonly repositoryDepartments: RepositoryDepartments,
    ) {
        makeObservable(this);

        autorun(() => {
            if (this.user === undefined) {
                return;
            }
            Sentry.setUser({ username: this.user.employeeId, id: this.user.id });
        });
    }

    @computed public get user(): User | undefined {
        // The frontend only works with UserLogin tokens, which is why
        // we can safely cast this to the expected type.
        const userId = this.serviceAuth.loginToken?.userId;
        if (!userId) {
            return undefined;
        }

        return this.repositoryUsers.byId(userId);
    }

    @computed public get userDepartment(): Department | undefined {
        if (!this.user || !this.user.departmentId) {
            return;
        }
        return this.repositoryDepartments.byId(this.user.departmentId);
    }
}
